require('../../modules/es6.object.get-own-property-descriptor');
var $Object = require('../../modules/_core').Object;
module.exports = function getOwnPropertyDescriptor(it, key){
  return $Object.getOwnPropertyDescriptor(it, key);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/fn/object/get-own-property-descriptor.js
 ** module id = 738
 ** module chunks = 0
 **/